<script setup>
import { computed } from 'vue'

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
})

const headingFontSize = computed(() => {
    switch (props.content.level) {
        case 'h1':
            return 'text-4xl sm:text-5xl'
        case 'h2':
            return 'text-3xl sm:text-4xl'
        case 'h3':
            return 'text-2xl sm:text-3xl'
        case 'h4':
            return 'text-xl sm:text-2xl'
        case 'h5':
            return 'text-lg sm:text-xl'
        case 'h6':
            return 'text-base sm:text-lg'
        default:
            return ''
    }
})
</script>

<template>
    <!-- content.level is like h1, h2, h3, etc. -->
    <component
        :is="content.level"
        :class="[headingFontSize, 'font-semibold tracking-tight text-pretty text-gray-900']"
    >
        {{ content.content }}
    </component>
</template>
